import React, { useContext, useEffect, useState } from 'react';
import { ProfileHeaderWrapper } from "./style";
import ContextDashboard from '../../../Context/ContextDashboard';
import { getDashboardData } from '../../../Utils/api';
import { getStorage } from '../../../Utils/common';

function ProfileHeader({ children }) {
  useContext(ContextDashboard);
  const [dashboard, setDashboard] = useState([]);


  // Fetch dashboard data on component mount
  useEffect(() => {
    const params = {
      profile_id: getStorage("cust_profile_id") || "",
    };

    getDashboardData(params).then(resp => {
      if (resp?.data?.Status === 1) {
        const dashboardData = resp?.data || {};
        setDashboard(dashboardData);
      }
    });
  }, []);


  // Check if active_loan_details has valid data
  const hasActiveLoanDetails = dashboard?.Data?.active_loan_details &&
    (dashboard?.Data?.active_loan_details?.total_due > 0 ||
    Object.keys(dashboard?.Data?.active_loan_details).length > 0);

  const fullName = dashboard?.Data?.full_name;
  const pan = dashboard?.Data?.profile_details?.pancard;
  const mobile = dashboard?.Data?.profile_details?.mobile;

  const initial = fullName ? fullName.trim().charAt(0).toUpperCase() : "?";

  return (
    <ProfileHeaderWrapper>
      <div className="ph-top">
        <div className="ph-avatar">
          <span className="ph-initial">{initial}</span>
          <span className="ph-status-dot" title="Profile in progress"></span>
        </div>

        <div className="ph-info">
          <div className="ph-name">{fullName || "Welcome back"}</div>
          <div className="ph-tagline">Complete your profile to unlock your loan</div>

          <div className="ph-chips">
            <div className="ph-chip">
              <div className="ph-chip-ic">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/></svg>
              </div>
              <div>
                <div className="ph-chip-label">PAN Card</div>
                <div className="ph-chip-val">{pan || <span className="ph-na">Not added</span>}</div>
              </div>
            </div>

            <div className="ph-chip">
              <div className="ph-chip-ic">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.6 3.41 2 2 0 0 1 3.58 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.78a16 16 0 0 0 6.29 6.29l1.06-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              </div>
              <div>
                <div className="ph-chip-label">Mobile</div>
                <div className="ph-chip-val">{mobile || <span className="ph-na">Not added</span>}</div>
              </div>
            </div>
          </div>

          {hasActiveLoanDetails && (
            <div className="ph-outstanding">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
              Outstanding Amount: ₹{dashboard?.Data?.active_loan_details?.total_due || "0"}
            </div>
          )}
        </div>
      </div>

      <div className="ph-cta">
        <div className="ph-cta-text">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          <p>Don't let uncertainty hold you back. It's time to explore the possibilities.</p>
        </div>
        {children}
      </div>
    </ProfileHeaderWrapper>
  );
}

export default ProfileHeader;
